import {
  IActionType,
  INormalAction,
  IPayloadAction,
  IAsyncAction,
} from './interface';
import FSM_CONSTANTS from '../../components/fseManagementSystem/utils/FSMContants';
import { openViewDefaultModal } from '../../components/fseManagementSystem/utils/openModal';

export const asyncActionTypeCreator = (actionName: string): IActionType => ({
  pending: `${actionName}_PENDING`,
  fulfilled: `${actionName}_FULFILLED`,
  rejected: `${actionName}_REJECTED`,
});
export const normalActionCreator = (type: string): INormalAction => ({
  type,
});
export const payloadActionCreator = (
  type: string,
  payload: any,
): IPayloadAction => ({
  type,
  payload,
});
export const httpMiddleware =
  () => (next: any) => (actionData: IAsyncAction) => {
    const {
      actionType,
      apiService,
      successCallBack,
      errorCallBack,
      successDataParser,
      payload = {},
      isShouldStoreResponse = true,
      isShouldOpenErrorModalInSuccess = false,
      isShouldOpenErrorModalInReject = false,
      queryString = '',
    } = actionData;
    if (!actionType) return next(actionData);
    const pending = (data: any) =>
      payloadActionCreator(actionType.pending, data);
    const fulfilled = (data: any) =>
      payloadActionCreator(
        actionType.fulfilled,
        (isShouldStoreResponse && data) || {},
      );
    const rejected = (data: any) =>
      payloadActionCreator(actionType.rejected, data);
    next(pending({}));
    const headerObj = {};
    return apiService({ queryString, payload, headerObj }).then(
      (response) => {
        const { data = { error: { errorCode: '', errorMsg: '' } } } = {
          ...response,
        };
        if (data.error && data.error.errorCode && data.error.errorMsg) {
          if (isShouldOpenErrorModalInSuccess) {
            next(
              openViewDefaultModal(
                data.error.errorMsg,
                'Error!',
                'default',
                'Ok',
                '',
                '50vw',
                'string',
                '',
                '',
                '',
              ),
            );
          } else {
            next(
              rejected({
                errorMsg: data.error.errorMsg,
              }),
            );
          }
          return Promise.reject(data);
        }
        // eslint-disable-next-line no-unused-vars
        const {
          statusCode = '',
          statusMessage = '',
          ...resData
        }: any = { ...data };
        if (successCallBack) {
          successCallBack(
            successDataParser ? successDataParser(resData) : resData,
          );
        }
        next(
          fulfilled(successDataParser ? successDataParser(resData) : resData),
        );
        return Promise.resolve(
          successDataParser ? successDataParser(resData) : resData,
        );
      },
      (error) => {
        if (errorCallBack) {
          errorCallBack(error);
        }
        if (isShouldOpenErrorModalInReject) {
          next(
            openViewDefaultModal(
              (error?.response && error?.response?.data?.message) ||
                FSM_CONSTANTS.TIMEOUT_ERROR,
              'Error!',
              'default',
              'Ok',
              '',
              '50vw',
              'string',
              '',
              '',
              '',
            ),
          );
        } else {
          next(
            rejected({
              errorMsg:
                (error?.response && error?.response?.data?.message) ||
                FSM_CONSTANTS.TIMEOUT_ERROR,
            }),
          );
        }
        return Promise.reject(error);
      },
    );
  };
